var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpbit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500.72 500.72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250.36,
    cy: 250.36,
    fill: "#093687",
    r: 250.36
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m235.08 340.09 44.66-135.69 21.51 7-15.37-50.79h132.93c24.12 0 36.67 21.55 28 48.05l-8.42 25.64c-.11.33-.23.65-.36 1l-.36.94a70.79 70.79 0 0 1 -9.53 17.66c-12.65 17.2-31.91 28.36-49.06 28.46h-1.27-65.47l-18.94 57.7zm87.11-87.69h35.41c8.86 0 18.66-7.92 21.84-17.65l8.7-26.47c3.2-9.74-1.41-17.65-10.25-17.65h-35.42zm-240.4 87.68a40.37 40.37 0 0 1 -4.52-.41 30.84 30.84 0 0 1 -7.33-1.81c-4.69-1.77-8.85-4.16-12-8.17a29.65 29.65 0 0 1 -4.47-8.07 34.06 34.06 0 0 1 -1.33-4.53c-1.71-7.77-1-15.57 1.14-23.17.18-.66 1.06-3.51 1.06-3.51l42.66-129.77h58.8l-43.3 131.81c-2.36 7.21-.53 13.62 4.64 16.33a10.72 10.72 0 0 0 5.43 1.31h29.07l49.08-149.45h66.5l-48.73 50.79 26.31-7-44.68 135.66z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpbit);
export default __webpack_public_path__ + "static/media/upbit.e87e65dcecbff02f024adaeff087b360.svg";
export { ForwardRef as ReactComponent };